/* jshint esversion:6 */

// 首页
// data = Request Payload, params = Query String Parameters
// 1.json格式 data:{ "key1": "value1", "key2": "value2" }
// 2.标准参数模式 params: "key1=value1&key2=value2"
// 3.json字符串（只适用于post） data: JSON.stringify({ "key1": "value1", "key2": "value2" })

import service from '@/utils/request'; 



/**
 * 获取AES加密公钥
 */
 export function getKey() {
    return service({
        url: '/login/getKey',
        method: 'get',
    });
}

/**
 * 获取热门课程
 */
export function getCourseRanking() {
    return service({
        url: '/index/getCourseRanking',
        method: 'post',
        // data = Request Payload, params = Query String Parameters
    });
}

/**
 * 获取课程推荐
 */
export function getCourseRecommend() {
    return service({
        url: '/index/getCourseRecommend',
        method: 'post',
        // data = Request Payload, params = Query String Parameters
    });
}

/**
 * 获取专题班推荐
 */
export function getTrainingClassRecommend() {
    return service({
        url: '/index/getTrainingClassRecommend',
        method: 'post',
        // data = Request Payload, params = Query String Parameters
    });
}

/**
 * 获取培训动态
 */
export function getTrainingNews(pageNo, pageSize) {
    return service({
        url: '/index/getTrainingNews',
        method: 'post',
        // data = Request Payload, params = Query String Parameters
        params: {
            pageNo,
            pageSize,
        }
    });
}

/**
 * 根据id获取对应通知详情
 */
export function getEmergencyNews(newsId) {
    return service({
        url: '/index/getEmergencyNews',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
        params: {
            newsId
        }
    });
}


/**
 * 获取通知公告列表
 */
export function getAnnounceNews() {
    return service({
        url: '/index/getAnnounceNews',
        method: 'post',
        // data = Request Payload, params = Query String Parameters
    });
}





// WEBPACK FOOTER //
// ./src/api/home.js


// WEBPACK FOOTER //
// ./src/api/home.js